module.exports = {
  MIN_YEAR: 2000,
  MAX_YEAR: 2050,
};
